import OrderDetail from "../features/order/OrderDetail";

const OrderDetailPage = () => {
  return <OrderDetail />;
};

export default OrderDetailPage;
